import { MobilePreview } from "components";
import { useMobile } from "hooks";
import { SectionLarge, FlexContainer, FlexColumn } from "styles";

export default function SectionMobilePreview({ children, invert, videoUrl, imageUrl }) {
	const isMobile = useMobile();

	const mobile = (
		<FlexContainer style={{ flex: 1, minWidth: 400 }}>
			<MobilePreview videoUrl={videoUrl} imageUrl={imageUrl} />
		</FlexContainer>
	);

	return (
		<SectionLarge>
			{!isMobile && !invert && mobile}
			<FlexColumn style={{ height: "100%", display: "flex", justifyContent: "space-evenly", flex: 2 }}>
				{children}
				{isMobile && <MobilePreview videoUrl={videoUrl} imageUrl={imageUrl} />}
			</FlexColumn>
			{!isMobile && invert && mobile}
		</SectionLarge>
	);
}
